import React from 'react'
import { View, ScrollView, SafeAreaView } from 'react-native'
import tw from 'tailwind-rn'
import { StackActions } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'

import { useSelector } from 'react-redux'
import { HGButton, HGHeading, HGText, HGView } from '../../components/HGUI'
import { RootStackParamList } from '../../navigators/AppNavigator'
import HansGretelLogo from '../auth/HansGretelLogo'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const NotFoundScreen = (props: Props) => {
  const { navigation } = props
  const { loggedIn } = useSelector((state) => state.user)

  return (
    <SafeAreaView style={tw('flex-1')}>
      <ScrollView>
        <HGView>
          <View style={tw('px-3')}>
            <View style={tw('mt-24 mb-8 self-center')}>
              <HansGretelLogo />
            </View>

            <HGHeading>Seite nicht gefunden</HGHeading>

            <HGText style={tw('mb-6')}>
              Leider haben wir die gewünschte Seite nicht gefunden. Kehren Sie
              zur Startseite zurück und versuchen Sie es erneut.
            </HGText>

            <HGButton
              title="Zurück zur Startseite"
              onPress={() =>
                navigation.replace(loggedIn ? 'SignedIn' : 'SignedOut')
              }
            />
          </View>
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default NotFoundScreen
